module.exports = __webpack_public_path__ + "img/prove7.94f905dd.png";